import { LanguageType } from './../../models/enum.model';
export class GetDashboard {
  static readonly type = '[Dashboard-State] Get Dashboard';
  constructor(public language: string) {}
}

export class GetBuildingsPerPeriod {
  static readonly type = '[Dashboard-State] Get Buildings Per Period';
  constructor() {}
}

export class GetBuildingsPerMunicipality {
  static readonly type = '[Dashboard-State] Get Get Buildings Per Municipality';
  constructor() {}
}

export class GetBuildingsPerManagement {
  static readonly type = '[Dashboard-State] Get Get Buildings Per Management';
  constructor() {}
}

export class GetUserInstruction {
  static readonly type = '[Dashboard-State] Get user instruction';
  constructor(public language: string) {}
}
